import {
  AUTH_LOGIN, AUTH_LOGOUT, SET_USER_STATE
} from '../mutation-types';
import AuthService from '../../services/auth.service';
import TokenService from '../../services/token.service';
import Http from '../../common/http';
import router from '../../router/router';
import { AbilityBuilder } from '@casl/ability';
import Vue from 'vue';

function hasRole(roles, role) {
  return roles.findIndex(r => r === role) !== -1;
}

// state
const state = () => ({
  user: JSON.parse(localStorage.getItem('user')) || {}
});

// mutations
const mutations = {
  [SET_USER_STATE](state, payload) {
    state.user = payload;
  }
};

// actions
const actions = {
  async [AUTH_LOGIN]({ commit, dispatch }, input) {
    return new Promise((async (resolve, reject) => {
      try {
        const response = await AuthService.login(input.username, input.password);

        const { token } = response.data;
        const { user } = response.data;
        commit(SET_USER_STATE, user);
        // Save token
        TokenService.saveToken(token);
        localStorage.setItem('user', JSON.stringify(user));

        // reset header
        Http.resetHeader();

        // Update ability
        dispatch('updateAbility');

        resolve(response);
      } catch (e) {
        reject(e);
      }
    }));
  },
  [AUTH_LOGOUT]() {
    // Remove token
    TokenService.removeToken();

    // Reset header
    Http.resetHeader();

    // Return login page
    router.push({
      name: 'login',
    });
  },
  updateAbility({state}) {
    const { can, rules } = new AbilityBuilder();
    const roles = state.user.roles || [];

    // @todo: need improve this function
    if (hasRole(roles, 'ROLE_ADMIN_SUPPER')) {
      can('manage', 'AdminUser');
    }

    Vue.prototype.$ability.update(rules);
  }
};

export default {
  state,
  mutations,
  actions,
};
